import { render, staticRenderFns } from "./UserNotificationsModal.vue?vue&type=template&id=368a842a&scoped=true"
import script from "./UserNotificationsModal.vue?vue&type=script&lang=js"
export * from "./UserNotificationsModal.vue?vue&type=script&lang=js"
import style0 from "./UserNotificationsModal.vue?vue&type=style&index=0&id=368a842a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368a842a",
  null
  
)

export default component.exports